import { isTablet } from "react-device-detect";
import styled, { css } from "styled-components";
const h = isTablet ? 95.8 : 100;
const Grid = /*#__PURE__*/styled.div.withConfig({
  displayName: "Grid",
  componentId: "sc-rx571g-0"
})(["display:grid;height:100%;grid-gap:1vh;grid-template-columns:400px calc(100vw - 400px - 3vh);", ""], ({
  three
}) => three ? css(["grid-template-rows:", "vh ", "vh;grid-template-areas:\"one two\" \"three three\";"], ({
  height
}) => h - 3 - height, ({
  height
}) => height) : css(["grid-template-rows:", "vh;grid-template-areas:\"two two\";"], h - 2));
Grid.AreaOne = styled.div.withConfig({
  displayName: "AreaOne",
  componentId: "sc-rx571g-1"
})(["grid-area:one;display:flex;flex-direction:column;"]);
Grid.AreaTwo = styled.div.withConfig({
  displayName: "AreaTwo",
  componentId: "sc-rx571g-2"
})(["grid-area:two;"]);
Grid.AreaThree = styled.div.withConfig({
  displayName: "AreaThree",
  componentId: "sc-rx571g-3"
})(["grid-area:three;"]);
Grid.displayName = "Grid";
Grid.AreaOne.displayName = `${Grid.displayName}.AreaOne`;
Grid.AreaThree.displayName = `${Grid.displayName}.AreaThree`;
Grid.AreaThree.displayName = `${Grid.displayName}.AreaThree`;
export default Grid;
//# sourceMappingURL=index.js.map